var map = {
	"./AdaIDE.dark.png": 8005,
	"./AdaIDE.darkplus.png": 6921,
	"./AdaIDE.default.png": 7730,
	"./AdaIDE.pink.png": 3309,
	"./CCmake.dark.png": 1253,
	"./CCmake.darkplus.png": 5849,
	"./CCmake.default.png": 578,
	"./CCmake.pink.png": 9981,
	"./DiffofTwoCompilers.dark.png": 1323,
	"./DiffofTwoCompilers.darkplus.png": 939,
	"./DiffofTwoCompilers.default.png": 6200,
	"./DiffofTwoCompilers.pink.png": 5211,
	"./DiffofTwoSources.dark.png": 8387,
	"./DiffofTwoSources.darkplus.png": 4355,
	"./DiffofTwoSources.default.png": 8640,
	"./DiffofTwoSources.pink.png": 4899,
	"./JavaIDE.dark.png": 4769,
	"./JavaIDE.darkplus.png": 197,
	"./JavaIDE.default.png": 5726,
	"./JavaIDE.pink.png": 6345,
	"./LLVMIR.dark.png": 435,
	"./LLVMIR.darkplus.png": 9603,
	"./LLVMIR.default.png": 5424,
	"./LLVMIR.pink.png": 2323,
	"./PascalIDE.dark.png": 5549,
	"./PascalIDE.darkplus.png": 2529,
	"./PascalIDE.default.png": 730,
	"./PascalIDE.pink.png": 8501,
	"./Preprocessor.dark.png": 6502,
	"./Preprocessor.darkplus.png": 7626,
	"./Preprocessor.default.png": 2595,
	"./Preprocessor.pink.png": 7158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4906;